import EditTheme from './EditTheme';

export default EditTheme;
